export const CHANGE_PASSWORD = '[ Account ] Change password'
export const CONFIRM_PASSWORD_CHANGE = '[ Account ] Confirm password change'

export const CONFIRM_ACCOUNT = '[ Account ] Confirm user'

export const REGISTER_ACCOUNT = '[ Account ] Register'
